import { ElLoading } from 'element-plus'

export const LOADING = (opt) => ElLoading.service({ lock: true, background: 'rgba(255, 255, 255, 0.9)', ...opt})

export const PHONE_NUMBER = '0575-87016392' // 87010553

export const HOUSE_TYPE = [
  {
    label: '不限',
    value: ''
  },
  {
    label: '普通住宅',
    value: '普通住宅'
  },
  {
    label: '联排',
    value: '联排'
  },
  {
    label: '叠排',
    value: '叠排'
  },
  {
    label: '别墅',
    value: '别墅'
  },
  {
    label: '商业',
    value: '商业'
  },
  {
    label: '写字楼',
    value: '写字楼'
  },
  {
    label: '其他',
    value: '其他'
  }
]

export const STORE_TYPE = [
  {
    label: '不限',
    value: ''
  },
  {
    label: '商铺',
    value: '商铺'
  },
  {
    label: '写字楼',
    value: '写字楼'
  }
]


export const LAND_TYPE = [
  {
    label: '不限',
    value: ''
  },
  {
    label: '商业用地',
    value: '商业用地'
  },
  {
    label: '农业用地',
    value: '农业用地'
  },
  {
    label: '工业用地',
    value: '工业用地'
  },
  {
    label: '住宅用地',
    value: '住宅用地'
  },
  {
    label: '其他土地',
    value: '其他土地'
  }
]

export const FACTORY_BUILDING_TYPE = [
  {
    label: '不限',
    value: ''
  },
  {
    label: '厂房',
    value: '厂房'
  },
  {
    label: '仓库',
    value: '仓库'
  }
]

export const DWELLING_SIZE = [
  {
    label: '不限',
    value: ''
  },
  {
    label: '一室',
    value: '1'
  },
  {
    label: '二室',
    value: '2'
  },
  {
    label: '三室',
    value: '3'
  },
  {
    label: '四室',
    value: '4'
  },
  {
    label: '五室及以上',
    value: '5'
  }
]

export const DIMENSION = [
  {
    label: '不限',
    value: ''
  },
  {
    label: '0-60m²',
    value: '0-60'
  },
  {
    label: '60-80m²',
    value: '60-80'
  },
  {
    label: '80-100m²',
    value: '80-100'
  },
  {
    label: '100-130m²',
    value: '100-130'
  },
  {
    label: '130-160m²',
    value: '130-160'
  },
  {
    label: '160-190m²',
    value: '160-190'
  },
  {
    label: '190-220m²',
    value: '190-220'
  },
  {
    label: '220-250m²',
    value: '220-250'
  },
  {
    label: '250m²以上',
    value: '250-99999'
  }
]

export const FACTORY_AREA = [
  {
    label: '不限',
    value: ''
  },
  {
    label: '0-100m²',
    value: '0-100'
  },
  {
    label: '100-200m²',
    value: '100-200'
  },
  {
    label: '200-300m²',
    value: '200-300'
  },
  {
    label: '300-500m²',
    value: '300-500'
  },
  {
    label: '500-700m²',
    value: '500-700'
  },
  {
    label: '700-1000m²',
    value: '700-1000'
  },
  {
    label: '1000以上',
    value: '1000-99999'
  }
]


export const STORE_AREA = [
  {
    label: '不限',
    value: ''
  },
  {
    label: '0-100m²',
    value: '0-100'
  },
  {
    label: '100-200m²',
    value: '100-200'
  },
  {
    label: '200-300m²',
    value: '200-300'
  },
  {
    label: '300-400m²',
    value: '300-400'
  },
  {
    label: '400-500m²',
    value: '400-500'
  },
  {
    label: '500m²以上',
    value: '500-99999999'
  },
]

export const LAND_AREA = [
  {
    label: '不限',
    value: ''
  },
  {
    label: '0-1000m²',
    value: '0-1000'
  },
  {
    label: '1000-2000m²',
    value: '1000-2000'
  },
  {
    label: '2000-3000m²',
    value: '2000-3000'
  },
  {
    label: '3000-5000m²',
    value: '3000-5000'
  },
  {
    label: '5000-7000m²',
    value: '5000-7000'
  },
  {
    label: '7000-10000m²',
    value: '7000-10000'
  },
  {
    label: '10000m²以上',
    value: '10000-9999999'
  }
]


export const SHORE_DIMENSION = [
  {
    label: '不限',
    value: ''
  },
  {
    label: '0-30m²',
    value: '0-30'
  },
  {
    label: '30-60m²',
    value: '30-60'
  },
  {
    label: '60-90m²',
    value: '60-90'
  },
  {
    label: '90-120m²',
    value: '90-120'
  },
  {
    label: '120-150m²',
    value: '120-150'
  },
  {
    label: '150-200m²',
    value: '150-200'
  },
  {
    label: '200-300m²',
    value: '200-300'
  },
  {
    label: '300m²以上',
    value: '300-99999'
  }
]


export const HOUSE_TOTAL_PRICE = [
  {
    label: '不限',
    value: ''
  },
  {
    label: '0-50万',
    value: '0-50'
  },
  {
    label: '50-80万',
    value: '50-80'
  },
  {
    label: '80-110万',
    value: '80-110'
  },
  {
    label: '110-140万',
    value: '80-100'
  },
  {
    label: '140-170万',
    value: '140-170'
  },
  {
    label: '170-200万',
    value: '170-200'
  },
  {
    label: '200-250万',
    value: '200-250'
  },
  {
    label: '250-300万',
    value: '250-300'
  },
  {
    label: '300-400万',
    value: '300-400'
  },
  {
    label: '400万以上',
    value: '400-99999'
  }
]

export const HOUSE_RENTAL_PRICE = [
  {
    label: '不限',
    value: ''
  },
  {
    label: '0-1000元',
    value: '0-1000'
  },
  {
    label: '1000-2000元',
    value: '1000-2000'
  },
  {
    label: '2000-3000元',
    value: '3000-3000'
  },
  {
    label: '3000-4000元',
    value: '3000-4000'
  },
  {
    label: '4000-5000元',
    value: '4000-5000'
  },
  {
    label: '5000-6000元',
    value: '5000-6000'
  },
  {
    label: '6000-7000元',
    value: '6000-7000'
  },
  {
    label: '7000元以上',
    value: '7000-99999'
  }
]

export const LAND_PRICE = [
  {
    label: '不限',
    value: ''
  },
  {
    label: '0-100万',
    value: '0-100'
  },
  {
    label: '100-300万',
    value: '100-300'
  },
  {
    label: '300-500万',
    value: '300-500'
  },
  {
    label: '500-700万',
    value: '500-700'
  },
  {
    label: '700-1000万',
    value: '700-1000'
  },
  {
    label: '1000-1500万',
    value: '1000-1500'
  },
  {
    label: '1500-2000万',
    value: '1500-2000'
  },
  {
    label: '2000万以上',
    value: '2000-999999'
  },
]

export const LAND_RENTAL_PRICE = [
  {
    label: '不限',
    value: ''
  },
  {
    label: '0-1000元',
    value: '0-1000'
  },
  {
    label: '1000-3000元',
    value: '1000-3000'
  },
  {
    label: '3000-5000元',
    value: '3000-5000'
  },
  {
    label: '5000-7000元',
    value: '5000-7000'
  },
  {
    label: '7000-10000元',
    value: '7000-10000'
  },
  {
    label: '10000-15000元',
    value: '10000-15000'
  },
  {
    label: '15000元以上',
    value: '15000-9999999'
  },
]

export const STORE_SALE_PRICE = [
  {
    label: '不限',
    value: ''
  },
  {
    label: '0-50万',
    value: '0-50'
  },
  {
    label: '50-100万',
    value: '50-100'
  },
  {
    label: '100-200万',
    value: '100-200'
  },
  {
    label: '200-300万',
    value: '200-300'
  },
  {
    label: '300-500万',
    value: '300-500'
  },
  {
    label: '500-700万',
    value: '500-700'
  },
  {
    label: '700-1000万',
    value: '700-1000'
  },
  {
    label: '1000万以上',
    value: '1000-99999999'
  },
]

export const HOUSE_FACE = [
  {
    label: '东',
    value: '东'
  },
  {
    label: '南',
    value: '南'
  },
  {
    label: '西',
    value: '西'
  },
  {
    label: '北',
    value: '北'
  },
  {
    label: '东南',
    value: '东南'
  },
  {
    label: '东北',
    value: '东北'
  },
  {
    label: '西南',
    value: '西南'
  },
  {
    label: '西北',
    value: '西北' 
  }
]


export const HOUSE_PRICE = [
  {
    label: '不限',
    value: ''
  },
  {
    label: '4000-7000',
    value: '4000-7000'
  },
  {
    label: '7000-10000',
    value: '7000-10000'
  },
  {
    label: '10000-13000',
    value: '10000-13000'
  },
  {
    label: '13000-15000',
    value: '13000-15000'
  },
  {
    label: '15000-18000',
    value: '15000-18000'
  },
  {
    label: '18000-21000',
    value: '18000-21000'
  },
  {
    label: '21000-24000',
    value: '21000-24000'
  },
  {
    label: '24000以上',
    value: '24000-99999'
  },
]


export const DECORATION = [
  {
    label: '毛坯',
    value: '毛坯'
  },
  {
    label: '简单装修',
    value: '简单装修'
  },
  {
    label: '中等装修',
    value: '中等装修'
  },
  {
    label: '精细装修',
    value: '精细装修'
  },
  {
    label: '豪华装修',
    value: '豪华装修'
  }
]


export const SEARCH_AREA = [
  {
    label: '不限',
    value: ''
  },
  {
    label: '暨阳街道',
    value: '暨阳街道'
  },
  {
    label: '浣东街道',
    value: '浣东街道'
  },
  {
    label: '暨南街道',
    value: '暨南街道'
  },
  {
    label: '陶朱街道',
    value: '陶朱街道'
  },
  {
    label: '大唐街道',
    value: '大唐街道'
  },

  {
    label: '店口镇',
    value: '店口镇'
  },
  {
    label: '枫桥镇',
    value: '枫桥镇'
  },
  {
    label: '次坞镇',
    value: '次坞镇'
  },
  {
    label: '牌头镇',
    value: '牌头镇'
  },
  {
    label: '安华镇',
    value: '安华镇'
  },
  {
    label: '山下湖镇',
    value: '山下湖镇'
  },
  {
    label: '璜山镇',
    value: '璜山镇'
  },
  {
    label: '五泄镇',
    value: '五泄镇'
  },
  {
    label: '姚江镇',
    value: '姚江镇'
  },
  {
    label: '应店街镇',
    value: '应店街镇'
  },
  {
    label: '同山镇',
    value: '同山镇'
  },
  {
    label: '赵家镇',
    value: '赵家镇'
  },
  {
    label: '东白湖镇',
    value: '东白湖镇'
  },
  {
    label: '浬浦镇',
    value: '浬浦镇'
  },
  {
    label: '陈宅镇',
    value: '陈宅镇'
  },
  {
    label: '岭北镇',
    value: '岭北镇'
  },
  {
    label: '马剑镇',
    value: '马剑镇'
  },
  {
    label: '东和乡',
    value: '东和乡'
  }
]

export const SHOP_TYPE = [
  {
    label: '不限',
    value: ''
  },
  {
    label: '商业街店铺',
    value: '商业街店铺'
  },
  {
    label: '临街门店',
    value: '临街门店'
  },
  {
    label: '档口摊位',
    value: '档口摊位'
  },
  {
    label: '社区店铺',
    value: '社区店铺'
  },
  {
    label: '写字楼配套',
    value: '写字楼配套'
  },
  {
    label: '商场门店',
    value: '商场门店'
  },
  {
    label: '其他',
    value: '其他'
  }
]

export const STORE_PRICE = [
  {
    label: '不限',
    value: ''
  },
  {
    label: '0-5万',
    value: '0-5'
  },
  {
    label: '5-10万',
    value: '5-10'
  },
  {
    label: '10-15万',
    value: '10-15'
  },
  {
    label: '15-20万',
    value: '15-20'
  },
  {
    label: '20-30万',
    value: '20-30'
  },
  {
    label: '30-50万',
    value: '30-50'
  },
  {
    label: '50-100万',
    value: '50-100'
  },
  {
    label: '100万以上',
    value: '100-99999'
  },
]

export const SALL_WAY = [
  {
    label: '不限',
    value: ''
  },
  {
    label: '整体',
    value: '整体'
  },
  {
    label: '分割',
    value: '分割'
  },
  {
    label: '均可',
    value: '均可'
  },
]

export const SOURCE = [
  {
    label: '不限',
    value: ''
  },
  {
    label: '个人',
    value: '个人'
  },
  {
    label: '中介',
    value: '中介'
  },
]